<template>
    <div class="guarantee-rate">
        <MyTitle theTitle="评价"/>
        <van-cell-group class="fd-com-scroll">
            <van-cell>
                请您对担保机构进行评价
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="5" class="col-key" align="left"><span class="color-text">*</span>担保速度</van-col>
                    <van-col span="18" class="col-value" offset="1">
                        <van-rate v-model="formData.nDbsdn"></van-rate>
                        <span class="rate-num">{{formData.nDbsdn * 2}}分</span>
                    </van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="5" class="col-key" align="left"><span class="color-text">*</span>服务水平</van-col>
                    <van-col span="18" class="col-value" offset="1">
                        <van-rate v-model="formData.nFwspn"></van-rate>
                        <span class="rate-num">{{formData.nFwspn * 2}}分</span>
                    </van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="5" class="col-key" align="left"><span class="color-text">*</span>理赔服务</van-col>
                    <van-col span="18" class="col-value" offset="1">
                        <van-rate v-model="formData.nLpfwn"></van-rate>
                        <span class="rate-num">{{formData.nLpfwn * 2}}分</span>
                    </van-col>
                </van-row>
            </van-cell>
            <van-field
                    clearable
                    disabled
                    label="评价"
            ></van-field>
            <van-field
                    class="evaluate-content"
                    v-model="formData.cYjjy"
                    :autosize="fieldSize"
                    type="textarea"
                    placeholder="请输入评价内容"
            ></van-field>
            <p style="padding: 0 0.4rem 0.4rem;color: red;font-size: 14px;">评价结果提交后将不能修改或撤销，请慎重操作！</p>
        </van-cell-group>
        <div class="fd-com-btn-container">
            <van-button
                type="info"
                round plain
                @click="goToMyGuarantee">
                关闭
            </van-button>
            <van-button
                type="info"
                round
                @click="submitEvaluateAndValidate">
                提交
            </van-button>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle'
    import Vue from 'vue';
    import {Rate,Dialog,Notify} from 'vant';
    import validate from '@/utils/validator/validator';
    import {
        cYjjyRule,
        nDbsdnRule,
        nFwspnRule,
        nLpfwnRule
    } from '@/utils/validator/rules';
    Vue.use(Rate);
    export default {
        components: {
            MyTitle,
        },
        data() {
            return {
                formData: {
                    cYjjy: '', // 意见建议
                    nDbsdn: 0, // 担保速度
                    nFwspn: 0, // 服务水平
                    nLpfwn: 0, // 理赔服务
                },
                radio: '1',
                fieldSize: {
                    maxHeight: 80,
                    minHeight: 80
                }
            }
        },
        methods: {
            goToMyGuarantee: function () {
                this.$router.push("/home/myGuarantee");
            },
            submitEvaluateAndValidate: function () {
                const validated = this.validateFormData();
                validated.then(() => {
                    this.submitEvaluate();
                });
            },
            submitEvaluate: function () {
                let currentDbid = sessionStorage.getItem("currentDbid");
                if (!currentDbid) {
                    this.$notify("获取担保id失败, 请返回上级页面重试");
                    return;
                }
                let evaluateInfo = {
                    cDbId: currentDbid,
                    // 0-10分，显示5颗星，1颗星表示2分
                    nDbsd: this.formData.nDbsdn * 2,
                    nFwsp: this.formData.nFwspn * 2,
                    nLpfw: this.formData.nLpfwn * 2,
                    cYjjy: this.formData.cYjjy
                };
                Dialog.confirm({
                    title: '提示',
                    message: '提交后，评价结果将不能修改或撤销，确认要提交吗？',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    this.$axios.post("ssbq/api/ssdb/dbpj", evaluateInfo)
                        .then(res => {
                            // 返回我的担保申请列表
                            this.goToMyGuarantee();
                        });
                });
            },
            validateFormData: function () {
                let descriptor = {
                    cYjjy: new cYjjyRule(true),
                    nDbsdn: new nDbsdnRule(true),
                    nFwspn: new nFwspnRule(true),
                    nLpfwn: new nLpfwnRule(true),
                };
                return validate(descriptor, this.formData);
            }
        }
    }
</script>

<style lang="less" scoped>
    .rate-radio-group {
        display: flex;
        float: left;
    }

    .color-text{
        color: red;
    }

    .guarantee-rate {
        overflow-y: scroll;
        height: 100%;
    }

    .evaluate-content {
        height: auto;
    }

    .rate-num{
        padding-left: 0.5rem;
    }
</style>
